import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["gradientColor", "children"];
import { Heading } from '@chakra-ui/react';
import { generateTextGradientFill } from '../../theme/gradients';
import { HomepageCardBackgroundGradient } from '../CUIHomepageCard/utils/backgroundGradients';
import { jsx as _jsx } from "react/jsx-runtime";
// We need to enforce the "as" property as required to ensure alignment with styleguide
export const CUIHeading = Heading;

/**
 * This is our wrapper of Chakra's Heading, with Connect.com gradients. See full docs on [Chakra-ui](https://chakra-ui.com/docs/components/heading/usage)
 */
export const CUIGradientHeading = _ref => {
  let {
      gradientColor = HomepageCardBackgroundGradient.magentaToOrange,
      children
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  return /*#__PURE__*/_jsx(CUIHeading, Object.assign({}, generateTextGradientFill(gradientColor), rest, {
    children: children
  }));
};